import React from 'react';

import UpcomingShows from './UpcomingShows';
import UpcomingCompetetion from './UpcomingCompetetion';
import { useAuth } from '../auth/Authcontext';
import { checkUserAuthorised } from '../utilities/authorisationcheck';



function Home() {

    const { user } = useAuth();
    const userRoles = user && user.scopes 

    return (
        <div className="container overflow-auto dashboard" >
            <h1>FanStable Dashboard</h1>
            {/* <p>Usage message</p> */}
        
            {
               checkUserAuthorised("canCreateShow" , userRoles) ? <UpcomingShows /> : <></>
            }
                    
            {
               checkUserAuthorised("canCreateCompetition" , userRoles) ? <UpcomingCompetetion /> : <></>
            }
            
            
            

        </div>
    )
}

export default Home;